import { useEffect } from 'react';
import { getCopyrightData } from '../utils/copyright';

/**
 * SEO Metadata component that dynamically updates page metadata
 * Includes copyright information in meta tags for SEO
 */
const SEOMetadata = ({ 
  title = '', 
  description = '', 
  keywords = '',
  includeCopyright = true 
}) => {
  useEffect(() => {
    const copyrightData = getCopyrightData();
    
    // Update document title
    const fullTitle = title ? `${title} - QuailGame Footy` : 'QuailGame Footy';
    document.title = fullTitle;
    
    // Update or create meta tags
    const updateMetaTag = (name, content) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('name', name);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };
    
    // Update description
    const fullDescription = description 
      ? `${description} ${copyrightData.description}`
      : `QuailGame - Manage your soccer teams and leagues. ${copyrightData.description}`;
    updateMetaTag('description', fullDescription);
    
    // Update copyright if enabled
    if (includeCopyright) {
      updateMetaTag('copyright', copyrightData.fullText);
      updateMetaTag('author', copyrightData.company);
    }
    
    // Update keywords
    const baseKeywords = 'soccer, football, league management, team management, sports, QuailGame';
    const fullKeywords = keywords ? `${keywords}, ${baseKeywords}` : baseKeywords;
    updateMetaTag('keywords', fullKeywords);
    
    // Open Graph tags for social media
    const updateOGTag = (property, content) => {
      let ogTag = document.querySelector(`meta[property="${property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', content);
    };
    
    updateOGTag('og:title', fullTitle);
    updateOGTag('og:description', fullDescription);
    updateOGTag('og:type', 'website');
    updateOGTag('og:site_name', 'QuailGame Footy');
    
    // Twitter Card tags
    const updateTwitterTag = (name, content) => {
      let twitterTag = document.querySelector(`meta[name="${name}"]`);
      if (!twitterTag) {
        twitterTag = document.createElement('meta');
        twitterTag.setAttribute('name', name);
        document.head.appendChild(twitterTag);
      }
      twitterTag.setAttribute('content', content);
    };
    
    updateTwitterTag('twitter:card', 'summary');
    updateTwitterTag('twitter:title', fullTitle);
    updateTwitterTag('twitter:description', fullDescription);
    
    // Cleanup function
    return () => {
      // Reset title when component unmounts
      document.title = 'QuailGame Footy';
    };
  }, [title, description, keywords, includeCopyright]);

  // This component doesn't render anything visible
  return null;
};

export default SEOMetadata;